import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import GridItem from 'components/Grid/GridItem.js';
import GridContainer from 'components/Grid/GridContainer.js';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from 'components/CustomButtons/Button.js';
import DateFnsUtils from '@date-io/date-fns';

const useStyles = (theme) => ({
  root: {
    '& .MuiFormControl-root': {
      margin: theme.spacing(2),
      width: 200,
      marginLeft: '1px',
    },
  },
  rootCircular: {
    flexGrow: 1,
    backgroundColor: '#f1f1f2',
  },
  green: {
    '& label.Mui-focused': {
      color: 'green',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'green',
    },
    width: '100% !important'
  },
  buttonAlign: {
    float: 'right',
  },
});

// preparando refatoração para componente funcional
// const [dateFrom, setDateFrom] = useState(null);
// const handleChangeDateFrom = (dateFrom) => setDateFrom(dateFrom);
// const [dateTo, setDateTo] = useState(null);
// const handleChangeDateTo = (dateTo) => setDateTo(dateTo);
// const [circular, setCircular] = useState(false);
// const handleCircular = () => setCircular(!circular);

class SearchEvents extends Component {
  state = {
    code: '',
    porta: '',
    finalField: '',
    finalValue: '',
  };

  handleClearInput = () => {
    this.setState({
      code: '',
      porta: '',
      dateFrom: null,
      dateTo: null,
      finalField: '',
      finalValue: '',
    });
  };

  handleChange = (event) => {
    const e = event.target.id ? event.target.id : event.target.name;
    const { value } = event.target;

    console.log(value)

    switch (e) {
      case 'code':
        this.setState({ code: value, finalField: e, finalValue: value });
        break;
      case 'porta':
        this.setState({
          porta: value,
          finalField: e,
          finalValue: value,
        });
        break;
    }
  };

  handleFilterTable = () => {
    const { filterTable } = this.props;
    const { finalField, finalValue, code, porta } = this.state;
    filterTable(finalField, finalValue, code, porta);
    this.handleClearInput();
  };

  render() {
    const { show, classes, codeAndOperations, portaFilter } = this.props;

    const { dateFrom, dateTo, code, porta } = this.state;

    if (!show) return null;

    return (
      <div className={classes.green}>
        <form className={classes.root} noValidate autoComplete="off">
          <h5>PESQUISAR EVENTOS</h5>

          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <TextField
                className={classes.green}
                select
                label="Evento"
                name="code"
                id="code"
                value={code}
                onChange={this.handleChange}
              >
                {codeAndOperations.map(({ codigo, operacao }) => (
                  <MenuItem key={codigo} value={codigo}>
                    {codigo + ' - ' + operacao}
                  </MenuItem>
                ))}
              </TextField>
            </GridItem>

            <GridItem xs={12} sm={6} md={6}>
              {/* <FormControl className={classes.green}>
                <InputLabel htmlFor="encomenda">Porta</InputLabel>
                <Input onChange={this.handleChange} name="porta" id="porta" />
              </FormControl> */}
              <TextField
                className={classes.green}
                select
                label="Porta"
                name="porta"
                id="porta"
                value={porta}
                onChange={this.handleChange}
              >
                {portaFilter.map(({ portaFilter }) => (
                  <MenuItem key={portaFilter} value={portaFilter}>
                    {portaFilter}
                  </MenuItem>
                ))}
              </TextField>
            </GridItem>
          </GridContainer>
          <Button onClick={this.handleFilterTable} color="primary" autoFocus>
            Pesquisar
          </Button>
        </form>
      </div>
    );
  }
}

export default withStyles(useStyles)(SearchEvents);
